import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

// "Mix por forma de pagamento" — ref. `ui-ux/prototipo-relatorio-vendas-kpis.html`:
// barra empilhada + valor e % de cada forma. O total e os % são calculados sobre
// a soma dos itens. Compartilhado entre `SalesReport` e `ServiceOrderReport`.
export default function PaymentMixPanel({ items, loading, totalGross = 0, totalNet = 0, subtitle = 'Participação no faturamento líquido do período', shareLabel = 'do faturamento' }) {
    const total = items.reduce((acc, it) => acc + it.value, 0);
    const brl = (v, digits = 0) => `R$ ${v.toLocaleString('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
    return (
        <Card sx={{ mb: '14px' }}>
            <CardContent sx={{ p: '14px 18px', '&:last-child': { pb: '14px' } }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, mb: '10px' }}>
                    <Box>
                        <Typography sx={{ fontSize: '14px', fontWeight: 700, color: 'text.primary' }}>Forma de pagamento</Typography>
                        <Typography sx={{ fontSize: '11.5px', color: 'text.secondary' }}>{subtitle}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'stretch', gap: { xs: '12px', sm: '18px' }, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                        {!loading && (
                            <>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
                                    <Typography sx={{ fontSize: '10.5px', lineHeight: '13px', fontWeight: 800, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '.05em' }}>Total Bruto</Typography>
                                    <Typography sx={{ fontSize: { xs: '14px', sm: '16px' }, fontWeight: 700, color: 'text.primary' }}>{brl(totalGross, 2)}</Typography>
                                </Box>
                                <Box sx={{ width: '1px', bgcolor: 'divider' }} />
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
                                    <Typography sx={{ fontSize: '10.5px', lineHeight: '13px', fontWeight: 800, color: 'primary.main', textTransform: 'uppercase', letterSpacing: '.05em' }}>Total Líquido</Typography>
                                    <Typography sx={{ fontSize: { xs: '14px', sm: '16px' }, fontWeight: 800, color: 'primary.main' }}>{brl(totalNet, 2)}</Typography>
                                </Box>
                            </>
                        )}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', height: 12, borderRadius: '8px', overflow: 'hidden', bgcolor: 'background.subtle', gap: '2px' }}>
                    {!loading && total > 0 && items.map((it) => (
                        <Box key={it.key} sx={{ height: '100%', width: `${(it.value / total) * 100}%`, bgcolor: it.color, transition: 'width .3s' }} />
                    ))}
                </Box>
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }, gap: '12px', mt: '12px' }}>
                    {items.map((it) => (
                        <Box key={it.key} sx={{ display: 'flex', flexDirection: 'column', gap: '2px', fontVariantNumeric: 'tabular-nums' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11.5px', fontWeight: 600, color: 'text.secondary' }}>
                                <Box component="i" sx={{ width: 9, height: 9, borderRadius: '3px', display: 'inline-block', bgcolor: it.color }} />
                                {it.label}
                            </Box>
                            {loading ? (
                                <Skeleton variant="text" width={90} height={22} />
                            ) : (
                                <>
                                    <Typography sx={{ fontSize: '15px', fontWeight: 800, color: 'text.primary' }}>{brl(it.value, 2)}</Typography>
                                    <Typography sx={{ fontSize: '10.5px', color: 'text.disabled' }}>
                                        {total > 0 ? Math.round((it.value / total) * 100) : 0}% {shareLabel}
                                    </Typography>
                                </>
                            )}
                        </Box>
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
}
